// @flow

/**
 * Module dependencies.
 */

import * as bootstrap from 'react-bootstrap';
import { gridGutterWidth, media } from 'client/styles';
import styled from 'styled-components';

/**
 * Export `Col`.
 */

export const Col = styled(bootstrap.Col)`
  padding-left: ${gridGutterWidth};
  padding-right: ${gridGutterWidth};
`;

/**
 * Export `ColFlex`.
 */

export const ColFlex = styled(Col)`
  ${media.min.sm`
    display: flex;
    flex-direction: column;
    justify-content: center;
  `}
`;

/**
 * Export `Container`.
 */

export const Container = styled(bootstrap.Grid)`
  max-width: 1600px;
  padding-left: ${gridGutterWidth};
  padding-right: ${gridGutterWidth};
  width: 100%;
`;

/**
 * Export `Row`.
 */

export const Row = styled(bootstrap.Row)`
  margin-left: ${gridGutterWidth};
  margin-right: ${gridGutterWidth};
`;

/**
 * Export `RowFlex`.
 */

export const RowFlex = styled(Row)`
  display: flex;
`;



// WEBPACK FOOTER //
// ../src/client/components/core/grid/bootstrap.js